import { Suspense } from "react";
import Loadable from "./Loadable";

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loader = ({ children }) => <Suspense fallback={<Loadable />}>{children}</Suspense>;

export default Loader;
